import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import agentRequestCloseAction from './agentRequestClose.action.json'

const agentRequestCloseDefinition = defineAction({
  ...agentRequestCloseAction,
  userActivityLogInput: 'omit' as const,
  input: object({
    entrepreneurCpf: string(),
    agentCpf: string(),
    cancellationReason: string(),
    cancellationReasonDetails: string().isOptional(),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      canceled: 'canceled',
    }),
    closedAt: dateTime(),
  }),
})

export default agentRequestCloseDefinition
